import { Component, Input } from "@angular/core";
import { Element } from "../../checklist.interface";
import { RideOpsUiService } from "source/app/configuration/services/rideops-ui.service";

@Component({
	selector: "app-element-template",
	templateUrl: "./element-template.component.html",
	styleUrls: ["./element-template.component.scss"],
})
export class ElementTemplateComponent {
	constructor(private rideOpsUi: RideOpsUiService) {}

	@Input() element: Element;

	isV2 = (): boolean => this.rideOpsUi.isV2Active();
}
